// extracted by mini-css-extract-plugin
export default {"navbarContainer":"Navbar_navbarContainer__IC5gz"};